import { Feature, type Map } from "ol";
import { store } from "../../../../stateManagement/store";
import { setTransportMonitoringCheckReady, setTransportMonitoringHovered, setTransportMonitoringLastShownFeaturesJson, setTransportMonitoringObject } from "../../../../stateManagement/reducers/transport/TransportNowSlice";
import { Point } from "ol/geom";
import { fromLonLat } from "ol/proj";
import GeoJSON from "ol/format/GeoJSON";
import { showToastMessage } from "../../../../stateManagement/reducers";

export function handleTransportSocketOpened() {
    const statusCircle = document.querySelector('.server-status-circle')
    statusCircle?.classList.remove('disconnected');
    statusCircle?.classList.add('connected')
}

export function handleTransportSocketClosed() {
    console.warn("Connection is closed");
    const statusCircle = document.querySelector('.server-status-circle')
    statusCircle?.classList.remove('connected')
    statusCircle?.classList.add('disconnected');
}

export function handleTransportSocketError() {
    console.warn(new Error("Websocket is null, probably it was closed"))
    const statusCircle = document.querySelector('.server-status-circle')
    statusCircle?.classList.remove('connected')
    statusCircle?.classList.add('disconnected');
}

let transportInfoBoxTimer: any;
export function hoverMapForTransportNow(event: any, map: Map) {
    const transportMonitoringHovered = store.getState().transportNow.transportMonitoringHovered
    if (event.dragging) {
        return;
    }
    var pixel = map?.getEventPixel(event.originalEvent);
    var feature = map?.forEachFeatureAtPixel(pixel, function (f: any) { return f; });
    if (feature) {
        let newId = feature.getProperties()?.id
        if (transportMonitoringHovered === null || transportMonitoringHovered?.id !== newId) {
            let speed = feature.getProperties()?.speed
            store.dispatch(setTransportMonitoringHovered({ id: newId, speed }));
        }
        const transportNowInfoBox: any = document.querySelector('.transport-now-info-box');
        if (transportNowInfoBox) {
            transportNowInfoBox.style.bottom = '100%'
            transportNowInfoBox.style.visibility = 'visible'
            clearTimeout(transportInfoBoxTimer);
            transportInfoBoxTimer = setTimeout(function () {
                transportNowInfoBox.style.bottom = '-100%'
                transportNowInfoBox.style.visibility = 'hidden'
            }, 5000);
        }
    }
}

export function clickMapForTransportNow(event: any, map: Map, navigate: any) {
    var pixel = map?.getEventPixel(event.originalEvent);
    var feature = map?.forEachFeatureAtPixel(pixel, function (f) { return f; });
    if (feature) {
        let id = feature.getProperties()?.objectId
        if (id) {
            navigate(`/app/transport/now/${id}`)
        } else {
            store.dispatch(showToastMessage({ messageText: "Карточка транспортного средства не заполнена", messageType: "info", windowType: "map" }))
        }
    }
}

export function configureTransportMoveFeaturesList(transportMonitoringObject: any, transportLayer: any, transportMonitoringCheckReady: any) {
    let newTransportLayer = transportLayer
    if (transportMonitoringObject.type && transportMonitoringObject.type === "VEHICLES") { // Пришли данные о ТС на карте
        const statusCircle = document.querySelector('.server-status-circle')
        statusCircle?.classList.remove('disconnected');
        statusCircle?.classList.remove('connected')
        statusCircle?.classList.add('connection')
        let timeout = setTimeout(function () {
            statusCircle?.classList.remove('connection')
            statusCircle?.classList.add('connected')
            clearTimeout(timeout);
        }, 2000);
        let vehicles = store.getState().transportNow.transportMonitoringFullList
        let moveList = transportMonitoringObject.move;
        if (vehicles) {
            moveList.map((item: any) => {
                let props: any = {}
                let existingFeature = newTransportLayer.getSource().getFeatureById(item.objectId);
                if (existingFeature === null) {
                    // Такого идентификатора не было - добавляем
                    existingFeature = new Feature({
                        geometry: new Point(fromLonLat([item.lon, item.lat]))
                    });
                    props = (vehicles.filter(function (value: any) {
                        return value.objectId == item.objectId
                    }))[0];
                    props = props == null ? {} : props;
                    let newProps = props.hasOwnProperty("objectId")
                        ? Object.assign({}, { ...props, id: props.objectId, azimuth: item.azimuth, speed: item.speed, showTransportBadge: true })
                        : Object.assign(props, { ...props, id: item.objectId, azimuth: item.azimuth, speed: item.speed, showTransportBadge: true });
                    existingFeature.setProperties(newProps);
                    existingFeature.setId(newProps.id);
                    newTransportLayer.getSource().addFeature(existingFeature);
                } else {
                    // Маркер есть на карте - надо его переместить
                    existingFeature.setGeometry(new Point(fromLonLat([item.lon, item.lat])));
                    // Обновить скорость и направление движения
                    props = existingFeature.getProperties();
                    props.azimuth = item.azimuth;
                    props.speed = item.speed;
                    existingFeature.setProperties(props);
                }
            })
        }
        // удалить метки с карты
        let removeList = transportMonitoringObject.remove;
        removeList.forEach(function (item: any) {
            let existingFeature = newTransportLayer.getSource().getFeatureById(item);
            if (existingFeature) {
                newTransportLayer.getSource().removeFeature(existingFeature);
            }
        });
    }
    var vectorLayerAsJson = new GeoJSON().writeFeaturesObject(newTransportLayer.getSource().getFeatures());
    store.dispatch(setTransportMonitoringObject(null))
    store.dispatch(setTransportMonitoringLastShownFeaturesJson(vectorLayerAsJson))
    store.dispatch(setTransportMonitoringCheckReady(!transportMonitoringCheckReady))
    return newTransportLayer
}
